<template>
  <div class="device-graph-table style">
    <div v-if="ready" class="device-graph style" style="color:#fff">
      <highcharts :options="chartOptions" :constructor-type="'stockChart'"></highcharts>
    </div>
  </div>
</template>

<script>
import graphConfigs from '../graphConfigs'
import { Chart } from 'highcharts-vue'
import stockInit from 'highcharts/modules/stock'
import Highcharts from 'highcharts'
import moment from 'moment'
import stationApi from '../../api/station'

stockInit(Highcharts)

export default {
  name: 'PowerForecast',
  mixins: [graphConfigs],
  components: { 'highcharts': Chart },
  created () {
    let id = this.$route.params.id
    let _this = this
    let twoDays = moment().add(2, 'hours').subtract(2, 'days')

    stationApi.forecastPowerComparison(id).then((r) => {
      r.data.forEach((value) => {
        let time = moment(value[0]).add(2, 'hours')
        let actualValue = (value[1][1] === 0) ? null : value[1][1]
        if (time > twoDays) {
          _this.chartOptions.series[0].data.push([time.valueOf(), actualValue])
          _this.chartOptions.series[1].data.push([time.valueOf(), value[1][0]])
        }
      })

      _this.ready = true
    })
  },
  data () {
    let now = moment().add(2, 'hours')

    return {
      ready: false,
      chartOptions: {
        title: {
          text: 'Power forecast',
          style:
              {
                'color': '#fff',
                'fontSize': '16px'
              }
        },
        rangeSelector: {
          selected: 1,
          buttons: [{
            type: 'day',
            count: 1,
            text: 'Day'
          },
          {
            type: 'all',
            text: 'All'
          }]
        },
        yAxis: [
          {
            title: {
              style: {
                color: '#fff'
              }
            },
            labels: {
              style: {
                color: '#fff'
              }
            },
            gridLineColor: '#595c5e'
          }
        ],
        xAxis: {
          labels: {
            style: {
              color: '#fff'
            }
          },
          plotLines: [{
            value: now.valueOf(),
            dashStyle: 'dash',
            width: 2,
            color: '#f36f37'
          }]
        },
        chart: {
          marginLeft: 25,
          marginRight: 25
        },
        series: [
          {
            data: [],
            name: 'Actual power',
            color: '#835fc1',
            tooltip: {
              valueSuffix: ' kW'
            }
          },
          {
            data: [],
            name: 'Forecast',
            dashStyle: 'Dash',
            color: '#019de7',
            tooltip: {
              valueSuffix: ' kW'
            }
          }
        ],
        tooltip: {
          dateTimeLabelFormats: {
            millisecond: '%A, %b %e'
          }
        }
      }
    }
  }
}
</script>
